<ng-container
  *ngLet="{
    disabled: defaultedDisabled | async,
    selected: defaultedSelected | async,
    autoFocus: defaultedAutoFocus | async,
    indeterminate: defaultedIndeterminate | async,
    expandable: defaultedExpandable | async,
    expanded: defaultedExpanded | async,
    title: defaultedTitle | async,
    count: defaultedCount | async,
    subtitle: defaultedSubtitle | async,
    titleHighlightIndices: defaultedTitleHighlightIndices | async,
    subtitleHighlightIndices: defaultedSubtitleHighlightIndices | async,
    identifier: defaultedIdentifier | async,
    subvertBox: subvertBox | async,
    subvertText: subvertText | async
  } as vm"
>
  <div class="multi-select-node">
    <tree-multi-select-checkbox
      class="checkbox"
      [disabled]="vm.disabled"
      [value]="vm.selected"
      (valueChange)="selectedChange.emit($event)"
      [indeterminate]="vm.indeterminate"
      [identifier]="vm.identifier"
      [subvertBox]="vm.subvertBox"
      [subvertText]="vm.subvertText"
      (click)="vm.subvertBox && expandedChange.emit()"
    >
      <span class="label" [title]="vm.title + ' ' + (vm.subtitle ?? '')">
        <span class="label-id rv-bold" *ngIf="displayId">
          {{ vm.identifier }} -
        </span>
        <span class="label-title">
          <a
            *ngIf="link; else title"
            class="rv-link"
            rivetLink
            [queryParams]="link.queryParams"
          >
            <ng-container [ngTemplateOutlet]="title"></ng-container>
          </a>
          <ng-template #title>
            <fuzzy-highlight
              [text]="vm.title"
              [indices]="vm.titleHighlightIndices"
            ></fuzzy-highlight>
          </ng-template>
        </span>
        <span *ngIf="vm.subtitle" class="label-subtitle">
          <fuzzy-highlight
            [text]="vm.subtitle"
            [indices]="vm.subtitleHighlightIndices"
          ></fuzzy-highlight>
        </span>
      </span>
      <span class="count">{{ vm.count | rivNumber }}</span>
    </tree-multi-select-checkbox>
    <button
      *ngIf="vm.expandable"
      rivButton
      [variant]="'ghost'"
      [size]="'medium'"
      class="chevron"
      type="button"
      (click)="expandedChange.emit()"
      [icon]="vm.expanded ? 'ChevronUp' : 'ChevronDown'"
    ></button>
  </div>
  <div *ngIf="vm.expanded" class="children"><ng-content></ng-content></div>
</ng-container>
